import { ACTION_LIST } from "../../../models/role/action";
import { SUBJECT_CIRCUIT_BREAKER } from "../../../models/role/subject";
import { lazyRetry } from "../../../utils/lazyRetry";
import { PAGE_URLS } from "../constants/PageUrls";

import type { ComponentType } from "react";
import type { Route } from "../../../routes/RouteModel";

const RiskRulesProxy = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "CircuitBreakerProxy" */
      "../pages"
    ),
  "CircuitBreakerProxy",
  (module: { RiskRulesProxy: ComponentType<any> }) => ({
    default: module.RiskRulesProxy,
  })
);

export const riskRulesRoute: Route = {
  component: RiskRulesProxy,
  i18nName: "Risk Rules",
  newTheme: true,
  path: PAGE_URLS.riskRules,
  can: {
    do: ACTION_LIST,
    on: SUBJECT_CIRCUIT_BREAKER,
  },
};
